import { useEffect } from "react";
import { scrollStore } from "@/lib/scrollStore";
import { isIOS } from "@/lib/webgl";

// iOS/Safari-only layer. Runs nothing on any other platform.
// 1) iOS Safari turns <body> into the scroll container when it has
//    overflow-x: hidden, which breaks position: fixed descendants.
//    Fix: switch the 3D stage to position: sticky (immune to that bug)
//    with a negative margin so layout is identical to the fixed version.
// 2) Height is synced to visualViewport (real visible height, toolbar-safe).
// 3) Scroll progress is re-pumped from element rects in case window
//    scroll events don't reach framer-motion's useScroll.
export function useIOS3DFix() {
    useEffect(() => {
        if (!isIOS()) return undefined;

        const cleanups = [];
        const stage = document.querySelector('[data-testid="product-stage"]');
        if (stage) {
            const apply = () => {
                const h = window.visualViewport ? window.visualViewport.height : window.innerHeight;
                stage.style.position = "sticky";
                stage.style.top = "0px";
                stage.style.left = "0";
                stage.style.width = "100%";
                stage.style.height = `${h}px`;
                stage.style.marginBottom = `-${h}px`;
                stage.style.transform = "translateZ(0)";
                stage.style.webkitTransform = "translateZ(0)";
            };
            apply();
            const vv = window.visualViewport;
            if (vv) {
                vv.addEventListener("resize", apply);
                cleanups.push(() => vv.removeEventListener("resize", apply));
            }
            window.addEventListener("orientationchange", apply);
            cleanups.push(() => window.removeEventListener("orientationchange", apply));
        }

        let raf;
        let lastY = -1;
        const clamp01 = (v) => Math.min(1, Math.max(0, v));
        const tick = () => {
            const y = window.scrollY || document.documentElement.scrollTop || 0;
            if (y !== lastY) {
                lastY = y;
                const vh = window.innerHeight;
                const hero = document.getElementById("inicio");
                const exp = document.getElementById("producto");
                if (hero) {
                    scrollStore.hero = clamp01(
                        -hero.getBoundingClientRect().top / Math.max(1, hero.offsetHeight - vh)
                    );
                }
                if (exp) {
                    scrollStore.exp = clamp01(
                        -exp.getBoundingClientRect().top / Math.max(1, exp.offsetHeight - vh)
                    );
                }
            }
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        cleanups.push(() => cancelAnimationFrame(raf));

        return () => cleanups.forEach((fn) => fn());
    }, []);
}
